import { Component, ViewChild } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DealerService, SpinnerService, AuthenticationService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { Dealer } from '../models';
import { Observable } from 'rxjs/Observable';
import { timer } from 'rxjs';
import { MenuItem } from 'primeng/api';
import * as moment from 'moment';

@Component({ templateUrl: 'tracking-log.component.html' })
export class TrackingLogComponent {
    currentUser: any;
    private sub: Subscription;
    DealerGuid: any;
    DealerId: any;
    DealerCode: any;
    DealerName: any;
    Street: any;
    City: any;
    State: any;
    DMS: any;
    TimeZone: any;
    ZIP: any;

    items: MenuItem[];
    activeItem: MenuItem;
    JobsCols: any;
    JobsLog: any;
    FilesCols: any;
    FilesLog: any;
    tabname = "Job logs";
    NA = 'NA';
    JobStartTime: any;
    @ViewChild('menuItems') menu: MenuItem[];
    constructor(
        private dealerService: DealerService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { }

    ngOnInit() {

        this.spinnerService.start();
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.sub = this.route.params.subscribe(
            params => {
                this.DealerId = params['id'];
                this.DealerGuid = params['guid'];
            }
        );

        if (this.DealerId != '0') {
            this.getDealerDetails();
            this.getTrackingLog();
        }
        else {
            this.spinnerService.stop();
        }

        this.items = [
            { label: 'Job logs' },
            { label: 'File transfer logs' },

        ];
        this.activeItem = this.items[0];
        const manageCdkdealerSearchtext = localStorage.getItem('manageCdkdealerSearchtext');
        localStorage.setItem('manageCdkdealersserachtextforback',manageCdkdealerSearchtext);
        localStorage.removeItem('manageCdkdealerSearchtext');
     
    }

    activateMenu() {
        this.activeItem = this.menu['activeItem'];
        this.tabname = this.activeItem.label;
    }
    getTrackingLog() {
        this.spinnerService.start();
        this.dealerService.getTrackingLog(this.DealerId).pipe(first()).subscribe(data => {

            //Jobs Log
            this.http.get('assets/data/jobs-log-header.json').subscribe(results => {
                this.JobsCols = results;
                if (data.jobList) {

                    this.JobsLog = data.jobList;
                    this.spinnerService.stop();
                }
                else {
                    this.spinnerService.stop();
                }
            });

            //Files Log 
            this.http.get('assets/data/file-transfer-log-header.json').subscribe(results => {
                this.FilesCols = results;
                if (data.jobFileList) {
                    this.FilesLog = data.jobFileList;
                    this.spinnerService.stop();
                }
                else {
                    this.spinnerService.stop();
                }
            });

        });

    }

    getDealerDetails() {
        this.dealerService.getDealerDetails(this.DealerGuid).pipe(first()).subscribe(data => {
            this.onDealerDetailsRetrieved(data);
        });

    }
    onDealerDetailsRetrieved(data: Dealer) {
        this.DealerCode = data[0].DealerCode;
        this.DealerName = data[0].DealerName;
        this.TimeZone = data[0].TimeZone;
        this.City = data[0].City;
        this.State = data[0].State;
        this.ZIP = data[0].Zip;
        this.spinnerService.stop();
    }
}